// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__36CBQ","search":"Settings_search__3fAfm","filter":"Settings_filter__XJSd2"};